/*银行到账 */
import { $http, buildHeaders } from "./index";

//获取到账公式列表
export const bankreceived_list = (params) => {
  return $http.get("/admin/BankReceived/index", { params });
};

//获取到账公示认领记录
export const bankreceived_getcollects = (id) => {
  return $http.get("/admin/BankReceived/getCollects", {
    params: {
      bank_received_id: id,
      sort_field: "create_time",
      sort_value: "desc",
    },
  });
};

//获取客户信息
export const bankreceived_getcustomer = () => {
  return $http.get("/admin/BankReceived/getCustomer", {
    params: {
      sort_field: "name",
      sort_value: "asc",
    },
  });
};

//获取到账公式详情
export const bankreceived_detail = (id) => {
  return $http.get("/admin/BankReceived/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加到账公式
export const bankreceived_add = (data) => {
  return $http.post("/admin/BankReceived/add", data, {
    headers: buildHeaders(3),
  });
};

//修改到账公式
export const bankreceived_edit = (data) => {
  return $http.post("/admin/BankReceived/edit", data, {
    headers: buildHeaders(3),
  });
};

//下载模板
export const bankreceived_download = () => {
  return $http.get("/admin/BankReceived/download", {
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//导入
export const bankreceived_import = (data) => {
  let headers = buildHeaders(3, "数据解析中，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/BankReceived/import", data, {
    headers,
  });
};

//导出
export const bankreceived_export = (params) => {
  return $http.get("/admin/BankReceived/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//到账公示冻结
export const bankreceived_freeze = (data) => {
  return $http.post("/admin/BankReceived/freezeStatus", data, {
    headers: buildHeaders(3),
  });
};

//到账公示认领确认/取消
export const bankreceived_check = (data) => {
  return $http.post("/admin/BankReceived/check", data, {
    headers: buildHeaders(3),
  });
};

//到账公示认领撤回
export const bankreceived_back = (data) => {
  return $http.post("/admin/BankReceived/back", data, {
    headers: buildHeaders(3),
  });
};

//到账公式修改匹配客户
export const bankreceived_editcustomer = (data) => {
  return $http.post("/admin/BankReceived/editCustomer", data, {
    headers: buildHeaders(3),
  });
};

//删除到账公式
export const bankreceived_delete = (id) => {
  return $http.post(
    "/admin/BankReceived/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
